<template>
<svg data-svg-lvl-2="flyleafend-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430">
<PreviewLayersFlyleafendBlockShadowR19 :params="params" />
<PreviewLayersFlyleafendBlockFlyleafendR19 :params="params" />
<PreviewLayersFlyleafendBlockContourR19 :params="params" />
<PreviewLayersFlyleafendBlockEnvelopeR :params="params" v-if="params.envelopeColor" />
<PreviewLayersFlyleafendBlockPocketR19 :params="params" v-if="params.flyleafendPocket" />
</svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>